import React, { useState, useEffect, useRef } from 'react';

import { Tab, Tabs, Modal, Row, Col, Button, Form, Accordion, Table, Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faCircleXmark, faPencilAlt, faPaperclip, faFileArrowDown, faFileLines, faEllipsisVertical, faDownload, faPaperPlane, faXmark, faStar } from '@fortawesome/free-solid-svg-icons';

import { Link } from 'react-router-dom';
import { withoutRFSToken, withRFSToken } from '../../../../Services/axios.js';
import { toast } from 'react-toastify';
import Select from 'react-select'
import { saveAs } from "file-saver";

import Docmnt from '../../../../assets/images/google-docs.png';
import msg_icon from "../../../../assets/images/recovery_inbox/msg_icon.png";
import msg_icon_hover from "../../../../assets/images/recovery_inbox/msg_icon_hover.png";
import send_icon from "../../../../assets/images/recovery_inbox/send_icon.png";
import compose_mail from "../../../../assets/images/recovery_inbox/compose_mail.png";

const Messages = ({ data }) => {

  const isMounted = useRef(false);
  const [messageLists, setMessageLists] = useState([]);
  const fileInputRef = useRef(null);
  const [files, setFiles] = useState([]);
  const [rfiles, setRfiles] = useState([]);
  const [base64Files, setBase64Files] = useState([]);

  const options = [];
  const [createMail, setCreateMail] = useState(false);
  const [getEmail, setGetEmail] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(null);

  const fetchMessageList = async (id) => {
    try {

      const res = await withRFSToken.post('service-recovery-message/list', { serviceRecoveryId: id })
        .then(function (res) {
          const innerData = res.data.response_data;
          setMessageLists(innerData);
          messageClick(innerData[0])
          if (innerData[0]?.messages?.length > 0) {
            const dta = {
              handler_email: innerData[0]?.handler_email,
              service_recovery_id: innerData[0]?.service_recovery_id,
              station_handler_id: innerData[0]?.station_handler_id
            }
            messageDetails(innerData[0]?.messages[0], '0', dta)
          }
        });

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const handleGetMail = async (val) => {
    if (val.length == 13) {
      try {
        const res = await withRFSToken.post('service-recovery-mail/get-handler-emails', { awbNumber: val })
          .then(function (res) {
            const innerData = res.data.response_data;
            // setMailForm({ ...mailForm, service_recovery_id: innerData.service_recovery_id })
            setMailForm(prevFormData => ({
              ...prevFormData,
              service_recovery_id: innerData.service_recovery_id
            }))
            const transMail = innerData ? innerData.receiver_data.map(item => ({
              value: item.receiver_id,
              email: item.receiver_email,
              label: item.handler_name + ' - ' + item.station_name + ' (' + item.receiver_email + ')',
            })) : [];
            setGetEmail(transMail);
          });

      } catch (error) {
        console.error('Error fetching data:', error);
      }
    }
  };

  useEffect(() => {
    if (isMounted.current) return;

    const storedData = JSON.parse(localStorage.getItem('RecoveryEdit'));
    if (storedData) {

      // if (storedData.selb) { setSelectedButton(storedData.selb) }
      fetchMessageList(storedData.service_recovery_id);

      handleGetMail(storedData.master_airway_bill_prefix + '-' + storedData.master_airway_bill_no)
      // setEditFiles(storedData.attachments)
      // loadDetails(storedData.service_recovery_id);
    }
    isMounted.current = true;

  }, []);

  const [selectedMsg, setSelectedMsg] = useState(null);
  const [msgDetails, setMsgDetails] = useState(null);
  const [mailForm, setMailForm] = useState({ type: 'H' });
  const [mailFiles, setMailFiles] = useState([]);

  const messageClick = (edata) => {
    console.log("🚀 ~ messageClick ~ data:", edata)
    setSelectedMsg(edata);
    setMsgDetails(null);
    const dta = {
      handler_email: edata?.handler_email,
      service_recovery_id: edata?.service_recovery_id,
      station_handler_id: edata?.station_handler_id
    }
    messageDetails(edata?.messages[0], 0, dta)
  }

  const messageDetails = async (edata, idx, loadData) => {
    let paylaod = {};
    if (loadData) {
      paylaod = {
        station_handler_id: loadData.station_handler_id,
        message_id: edata?.message_id,
        service_recoveries_id: loadData.service_recoveries_id,
        handler_email: loadData.handler_email
      }
    } else {
      paylaod = {
        station_handler_id: selectedMsg?.station_handler_id,
        message_id: edata?.message_id,
        service_recoveries_id: selectedMsg?.service_recoveries_id,
        handler_email: selectedMsg?.handler_email
      }
    }
    // console.log("🚀 ~ messageDetails ~ paylaod:", paylaod)
    try {

      const res = await withRFSToken.post('service-recovery-message/details', paylaod)
        .then(function (res) {
          const innerData = res.data.response_data;
          setMsgDetails(innerData);
          setSelectedIndex(idx);
        });

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }


  // NEW MAIL
  const createMailOpen = () => {
    // handleReplyClose();
    setCreateMail(true);
    setMailForm({ type: 'H' });
    setFiles([])
    setMailFiles([]);
    setBase64Files([]);
  }
  const createMailClose = () => {
    setCreateMail(false);
    setMailForm({ type: 'H' });
    setFiles([])
    setMailFiles([]);
    // setBase64Files([]);
  };
  const handleMailChange = (fieldName, value) => {

    setMailForm(prevFormData => ({
      ...prevFormData,
      [fieldName]: value
    }))
  };

  // IMAGE UPLOAD START

  const handleDeleteFile = (index, pos) => {
    setFiles((prevFiles) => {
      const newFiles = [...prevFiles];
      newFiles.splice(index, 1);
      return newFiles;
    });
    setMailFiles((prevFiles) => {
      const newFiles = [...prevFiles];
      newFiles.splice(index, 1);
      return newFiles;
    });
    if (pos == 'R') {
      setRfiles((prevFiles) => {
        const newFiles = [...prevFiles];
        newFiles.splice(index, 1);
        return newFiles;
      });
    }
    // base64Files.splice(index, 1);
    setBase64Files((prevBase64Files) => {
      const newBase64Files = [...prevBase64Files];
      newBase64Files.splice(index, 1);
      if (pos == 'R') {

        // setSendData((prevFormData) => {
        //   // const newFiles = [...prevFormData.files];
        //   const newFiles = Array.isArray(prevFormData.files) ? [...prevFormData.files] : [];
        //   newFiles.splice(index, 1);
        //   return { ...prevFormData, files: newFiles };
        // });
      }
      // Update local storage


      return newBase64Files;
    });
  };

  const handleBrowseFiles = (e, nam) => {
    fileInputRef.current.click();
  };



  function getBase64(file) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      setBase64Files((prevBase64Files) => [...prevBase64Files, reader.result]);
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  }

  const handleFileChange = (e, pos, chk) => {

    const selectedFiles = Array.from(e.target.files);
    const filesWithBase64 = [];
    let filesProcessed = 0;

    // const existingData = JSON.parse(localStorage.getItem(keyType)) || {};
    const existingBase64Files = data?.base64Files || [];

    selectedFiles.forEach((file) => {
      const reader = new FileReader();
      reader.onloadend = async () => {
        if (file.size > 26214400) {
          toast.error(`${file.name} is too large. Maximum file size is 25MB.`);
          return;
        }
        filesWithBase64.push({ file, base64: reader.result, file_name: file.name, type: file.type });
        filesProcessed += 1;
        if (filesProcessed === selectedFiles.length) {

          const newFiles = filesWithBase64.map((obj) => obj.file);
          console.log("🚀 ~ reader.onloadend= ~ newFiles:", filesWithBase64);
          let newBase64Files;
          if (pos === 'C') {
            newBase64Files = filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name, category: [chk] }));
          } else {
            newBase64Files = filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }));
          }
          console.log('newBase64Files', newBase64Files);

          // const newBase64Files = filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }));
          const mergedBase64Files = [...existingBase64Files, ...newBase64Files];

          // setFiles((prevFiles) => [...prevFiles, ...newFiles]);
          setFiles((prevFiles) => [...prevFiles, ...filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }))]);
          setBase64Files(mergedBase64Files);
          if (pos == 'R') {
            setRfiles((prevFiles) => [...prevFiles, ...filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name, type: obj.type }))]);
            // setSendData((prevFormData) => {
            //   // const newFormData = { ...prevFormData, files: newFiles, base64Files: mergedBase64Files };
            //   const newFormData = { ...prevFormData, attachments: mergedBase64Files };

            //   return newFormData;
            // });
          }
          if (pos == 'M') {
            // const newFiles = filesWithBase64.map((obj) => obj.file);
            setMailFiles((prevFiles) => [...prevFiles, ...newFiles]);
            setMailForm((prevFormData) => {
              // const newFormData = { ...prevFormData, files: newFiles, base64Files: mergedBase64Files };
              const newFormData = { ...prevFormData, attachments: mergedBase64Files };

              return newFormData;
            });
          }

          // }
        }
      };
      reader.readAsDataURL(file);
    });


  };

  // IMAGE UPLOAD END

  const validateMailData = () => {
    let isValid = true;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // Function to validate email
    const validateEmail = (email) => {
      return emailRegex.test(email);
    };
    if (!mailForm.receiver) {
      toast.error('Invalid email address');
      isValid = false;
    } else if (mailForm.receiver[0].receiver_email == '') {
      toast.error('Insert valid email address');
      isValid = false;
    } else if (!mailForm.type) {
      toast.error('Company Name must not be blank');
      isValid = false;
    } else if (!mailForm.subject) {
      toast.error('Please enter Subject');
      isValid = false;
    } else if (mailForm.awbNumber && mailForm.awbNumber.length !== 13) {
      toast.error('Please enter proper AWB Number');
      isValid = false;
    } else if (!mailForm.message) {
      toast.error('Please enter message');
      isValid = false;
    }
    else {
      return isValid;
    }
  };
  const sendMessage = async (pos, datas) => {
    // if (validateMailData()) {
    let paylaod = {}
    if (pos == 'R') {
      const tranData = msgDetails.details.receiver.map(item => {
        const { station_handler_id, ...rest } = item;
        return {
          ...rest,
          receiver_id: station_handler_id
        };
      })
      paylaod = { ...mailForm, receiver: tranData, service_recovery_id: data.service_recovery_id, message_id: datas?.message_id }
    } else {
      paylaod = { ...mailForm, service_recovery_id: data.service_recovery_id }
    }
    // console.log('mailForm', paylaod);

    try {
      const res = await withRFSToken.post('service-recovery-message/save', paylaod);
      // .then(function (res) {
      if (res.data.response_code == 200) {
        toast.success(res.data.response_msg);
        setMailForm({ type: 'H', message: '' });
        setFiles([]);
        setMailFiles([])
        if (pos == 'R') {
          // setReplyMail(null)
          messageDetails(datas, selectedIndex);

        } else {
          fetchMessageList(data.service_recovery_id);
          createMailClose();
          // setCreateMail(false);
        }
      }
      // });

    } catch (error) {
      console.error('Error fetching data:', error);
    }
    // }
  };

  function extractPath(url) {
    try {
      let urlObject = new URL(url);
      let path = urlObject.pathname.substring(1);
      return path;
    } catch (error) {
      console.error("Invalid URL:", error);
      return null;
    }
  }
  const handleDownload = async (imageUrl, imageName) => {
    const path = extractPath(imageUrl);
    const res = await withRFSToken
      .post("get-file-blob", {
        file_path: path,
      })
      .then((response) => {
        const pdfData = atob(response.data.response_data.file_base64);
        const byteNumbers = new Array(pdfData.length);
        for (let i = 0; i < pdfData.length; i++) {
          byteNumbers[i] = pdfData.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], {
          type: response.data.response_data.mime_type,
        });
        saveAs(blob, imageName);
      })
      .catch((error) => {
        console.error("Error during the file download:", error);
        alert("Could not download the file");
      });
  };

  return (
    <div className="service_recovery_leftpart">
      <Row>
        <Col lg={3} className="p-0">
          <div className="service_recovery_msg">
            <h5>Messages</h5>
            <div className="">
              <div className="nav flex-column nav-pills me-0" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                {/* {messageLists?.map((msg, index) => ( */}
                  <button className={`nav-link active`} id="v-pills-home-tab" data-bs-toggle="pill" data-bs-target="#v-pills-home" type="button" role="tab" aria-controls="v-pills-home" aria-selected="true">
                    <div className="title_wrap d-flex align-items-center">
                      <div className="icon">
                        <img src={msg_icon} alt="" className="pe-3" />
                      </div>
                      <div className="title">
                        <h6 className="mb-1">Airline</h6>
                        <p className="mb-0">{data.created_by}</p>
                      </div>
                      {/* <span>{msg.messages.length > 0 ? msg.messages.length : 0}</span> */}
                    </div>
                  </button>
                {/* ))} */}
              </div>
            </div>
          </div>
        </Col>
        <Col lg={9} className="p-0">
          {selectedMsg?.messages.length > 0 &&
            <div className="tab-content" id="v-pills-tabContent">
              <div className="tab-pane fade show active" id="v-pills-home" role="tabpanel" aria-labelledby="v-pills-home-tab">
                <div className="mail_msg_dv_wrap h-100">
                  <div className="top_dv d-flex justify-content-between align-items-center">
                    <div className="aae_icon_dv d-flex align-items-center">
                      <div className="aae_icon">
                        <img src={msg_icon_hover} alt="" className="pe-3" />
                      </div>
                      <div className="aaetitle ps-3">
                        <h6 className="mb-0">{selectedMsg.station_code}</h6>
                        <p className="mb-0">{selectedMsg.handler_name}</p>
                      </div>
                    </div>
                    <div className="wrap text-end">
                      {/* <span className="setting_dv me-3"><span><img src={setting} alt="" className="pe-2" /></span>Settings</span> */}
                      <Button variant="primary" disabled={data.recovery_status == 'Closed'} className="compose_mail_btn ms-3" onClick={createMailOpen}><span><img src={compose_mail} alt="" /></span> New Email</Button>
                    </div>
                  </div>
                  <div className="bottom_dv">
                    <Row>
                      <Col lg={4}>
                        <div className="email_dv">
                          {selectedMsg?.messages?.map((sub, index) => (
                            <div className={`mail_list d-flex justify-content-between ${index == selectedIndex ? 'mail_list_active' : ''}`} onClick={() => messageDetails(sub, index)}>
                              <div className="mail_list_wrap d-flex">
                                <span className="mail_no">{index + 1}</span>
                                <span className="mailbdy_shorty">
                                  <h6 className="mb-1">{sub.subject}</h6>
                                  <p className="mb-0">Airline</p>
                                </span>
                              </div>
                              <div className="mail_timing text-end">
                                <span><p className="mb-0">{sub.created_date ? sub.created_date : sub.created_time}</p>{sub.total_messages !== 0 && <p className="mb-0 mail_amount_count">{sub.total_messages}</p>}</span>
                              </div>
                            </div>
                          ))}
                        </div>
                      </Col>
                      <Col lg={8}>
                        <div className="mail_chatBox h-100">
                          {msgDetails &&
                            <>
                              <div className="chatBox_title">
                                <div className="row">
                                  <div className="col-md-6">
                                    <div className="mail_list_wrap d-flex">
                                      <span className="mail_no">01</span>
                                      <span className="mailbdy_shorty">
                                        <h6 className="mb-1">{msgDetails?.details?.receiver[0]?.receiver_email}</h6>
                                        <p className="mb-0">Dummy Text</p>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="chatboxbody">

                                <div className="chatbox">
                                  <div className="msg-body chatBoxMsg">
                                    <div className="divider msg-body">
                                      <h6>Yesterday</h6>
                                    </div>
                                    <ul>
                                      {msgDetails?.messages?.map((convo, index) => (
                                        <li className={convo.chat_type == 'received' ? 'repaly' : 'sender'}>

                                          <div className={convo.chat_type == 'received' ? 'my_text_right' : 'my_text_left'}>
                                            {convo?.attachments?.length > 0 &&
                                              <div className="attachment-area-div">
                                                <div className="upload-file">
                                                  {convo?.attachments?.map((file, index) => {
                                                    const fileName = file?.file_name;
                                                    const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                                                    const extension = fileName?.split(".").pop();
                                                    return (
                                                      <>
                                                        <div key={`ns_${index}`} className="upload-file-1">
                                                          {["jpeg", "jpg", "png", "webp"].includes(file.file_path?.split(".")[file.file_path?.split(".").length - 1]
                                                          ) ? (
                                                            <>
                                                              <div className="upload-file-icon">
                                                                <img
                                                                  src={file.file_path}
                                                                  alt="Preview"
                                                                  className=''
                                                                  style={{
                                                                    maxWidth: "30px",
                                                                    maxHeight: "30px",
                                                                    marginRight: "5px",
                                                                  }}
                                                                // onClick={() => handleFileClick(URL.createObjectURL(file))}
                                                                // onClick={() =>
                                                                //     handleFileClick(file.file_path)
                                                                // }
                                                                />
                                                              </div>
                                                            </>
                                                          ) : (
                                                            <>
                                                              <span className="d-flex rafilename">
                                                                <img src={Docmnt} className="fileimg" />
                                                              </span>
                                                            </>
                                                          )}
                                                          <div className="upload-text">
                                                            <h3>{baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 7)}... .${extension}`}</h3>
                                                          </div>

                                                          <Link to="#" className="slide_dwnldbtn" onClick={() => handleDownload(file.file_path, file.file_name)}>
                                                            <FontAwesomeIcon icon={faDownload} />
                                                          </Link>

                                                          {/* <button
                                                                  className="msg_download"
                                                                  type="button"
                                                                  onClick={() =>
                                                                      handleDownload(file.file_path, file.file_name)
                                                                  }
                                                              >
                                                                  <FontAwesomeIcon icon={faFileArrowDown} />
                                                              </button> */}
                                                        </div>
                                                      </>
                                                    );
                                                  })}
                                                </div>
                                              </div>
                                            }
                                            <p> {convo.message} </p>
                                          </div>


                                          <span className="time">{convo.created_date !== '' ? convo.created_date : convo.created_time}</span>
                                        </li>
                                      ))}
                                    </ul>
                                  </div>

                                  {data.recovery_status == 'Closed' &&
                                    <div className='close_msg'>"<span>Close Recovery</span>" refers to finalizing or completing a recovery plan or strategy,<br />often in the context of business, health care or personal well-being.</div>
                                  }

                                  {/* {console.log('mailForm', mailForm)} */}
                                  {data.recovery_status == 'Closed' ? '' :
                                    <div className='snd_bx_wrap'>
                                      <div className="send-box">
                                        <span className="chatter_nm">AR</span>
                                        <textarea id="user-input" placeholder="Reply" onChange={(e) => handleMailChange('message', e.target.value)} value={mailForm.message || ''}></textarea>
                                        <div className='msg_snd'>
                                          <img src={send_icon} alt="" className="send-btn" onClick={() => sendMessage('R', msgDetails?.details)} />
                                          <div className='d-flex flex-wrap reco_image'>
                                            {mailFiles.map((file, index) => {
                                              const fileName = file?.name;
                                              const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                                              const extension = fileName?.split(".").pop();
                                              return (
                                                <div key={index} className='img-thumbnail'>
                                                  {file.type.startsWith('image/') ? (
                                                    <img
                                                      src={URL.createObjectURL(file)}
                                                      alt="Preview"
                                                      style={{ maxWidth: '30px', maxHeight: '30px', marginRight: '10px' }}
                                                    />
                                                  ) : (
                                                    <span className=''><img src={Docmnt} className='fileimg' />  </span>
                                                  )}
                                                  <span className="rafilename">
                                                    {baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 7)}... .${extension}`}
                                                  </span>
                                                  <button className='dltbtn' type="button" onClick={() => handleDeleteFile(index)}> <FontAwesomeIcon icon={faCircleXmark} color='#656565' /></button>
                                                </div>
                                              )
                                            })}
                                          </div>
                                          <Link to='#' className="attach_file_icon" onClick={handleBrowseFiles}> <FontAwesomeIcon icon={faPaperclip} /> </Link>
                                          {/* <img src={attach} alt="" className="attach_file_icon" onClick={handleBrowseFiles} /> */}
                                          {/* <input type="file" name="upload" id="upload" className="upload-box" placeholder="Upload File" aria-label="Upload File" /> */}
                                          <div className='mag_send'>
                                            <input
                                              type="file"
                                              ref={fileInputRef}
                                              className="upload-box"
                                              style={{ display: 'none' }}
                                              onChange={(e) => handleFileChange(e, 'M')}
                                              multiple
                                            />
                                          </div>
                                        </div>

                                      </div>
                                    </div>
                                  }

                                </div>
                              </div>
                            </>
                          }
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          }
        </Col>
      </Row>
      <Modal className='addfrom new_mail_modal' show={createMail} onHide={() => createMailClose()} centered size='lg'>
        <Modal.Header closeButton>
          <Modal.Title>New Mail</Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <Form>
            {/* <Row className="separate">
                              <Form.Group as={Col} md="12" className="d-flex align-items-center" controlId="formBasicEmail">
                                  <Form.Label className='awb_ref'>AWB Reference:</Form.Label>
                                  <Form.Control type="text" placeholder="000-0000 0000" name='awbNumber' maxLength={13} value={mailForm.awbNumber || ''} onChange={(e) => handleMailChange('awbNumber', e.target.value)} />
                              </Form.Group>
                          </Row> */}

            <Row className="separate">
              <Form.Group as={Col} md="12" className="d-flex align-items-center  " controlId="formBasicEmail">
                <Form.Label>To:</Form.Label>
                <Select
                  options={getEmail}
                  onChange={(selected) => {
                    const selectedValues = selected ? selected.map(option => ({ receiver_id: option.value, receiver_email: option.email })) : [];
                    setMailForm({ ...mailForm, receiver: selectedValues });
                  }}
                  placeholder="example@gmail.com"
                  className='down_selct'
                  isMulti
                  // value={getEmail.find(option => option.value === selectedOpt)}
                  value={options.value}
                />
              </Form.Group>
              {/* <Form.Group as={Col} md="3" >
                                              <Form.Select aria-label="Default select example" name='type' value={mailForm.type} onChange={(e) => handleMailChange('type', e.target.value)}>
                                                  <option value='A'>Airline</option>
                                                  <option value="H">Handler</option>
                                              </Form.Select>
                                          </Form.Group> */}
            </Row>
            <Row className="separate">
              <Form.Group as={Col} md="12" className="d-flex align-items-center" controlId="formBasicEmail">
                <Form.Label>Subject:</Form.Label>
                <Form.Control type="text" placeholder="Enter your text" name='subject' onChange={(e) => handleMailChange('subject', e.target.value)} />
              </Form.Group>
            </Row>
            <Form.Group className='mb-2'>
              <Form.Control type="text" placeholder="Enter Your Description here" name='message' as="textarea" rows={8} className='' onChange={(e) => handleMailChange('message', e.target.value)} />
              {/* <MessageBox
                                  message_area={"uld"}
                                  onMessageChange={(val) => {
                                      setMailForm(prev => ({
                                          ...prev,
                                          message: val
                                      }));
                                  }}
                              // commentable_id={selectedRowData.uld_number}
                              // allactivities={selectedRowData.activities}
                              // onReloadDetails={loadDetails}
                              /> */}
            </Form.Group>

            <div className='d-flex flex-wrap reco_image'>
              {mailFiles.map((file, index) => {
                const fileName = file?.name;
                const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                const extension = fileName?.split(".").pop();
                return (
                  <div key={index} className='img-thumbnail'>
                    {file.type.startsWith('image/') ? (
                      <img
                        src={URL.createObjectURL(file)}
                        alt="Preview"
                        style={{ maxWidth: '30px', maxHeight: '30px', marginRight: '10px' }}
                      />
                    ) : (
                      <span className=''><img src={Docmnt} className='fileimg' />  </span>
                    )}
                    <span className="rafilename">
                      {baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 7)}... .${extension}`}
                    </span>
                    <button className='dltbtn' type="button" onClick={() => handleDeleteFile(index)}> <FontAwesomeIcon icon={faCircleXmark} color='#656565' /></button>
                  </div>
                )
              })}
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <div className='d-flex align-items-center send_mail'>
            <Link to='#' onClick={handleBrowseFiles}> <FontAwesomeIcon icon={faPaperclip} /> </Link>
            <Button variant="primary" onClick={() => sendMessage()}> Send <FontAwesomeIcon icon={faPaperPlane} /> </Button>
          </div>
          <div className='mag_send'>
            <input
              type="file"
              ref={fileInputRef}
              style={{ display: 'none' }}
              onChange={(e) => handleFileChange(e, 'M')}
              multiple
            />

          </div>

        </Modal.Footer>
      </Modal>
    </div>
  )
}

export default Messages